import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';
import ButtonBase from '@material-ui/core/ButtonBase';
import Layout from '../../components/layout';
import LightboxZoom from '../../components/LightboxZoom';
import ImgFundoEmpresa from '../../images/fundo-empresa.jpg';
import getConfigDiferenciais from '../../data/configDiferenciais';
import getConfigGaleriaEmpresa from '../../data/configGaleriaEmpresa';

export default ({ location }) => {
  const intl = useIntl();

  const configDiferenciais = getConfigDiferenciais({ intl });
  const configGaleriaEmpresa = getConfigGaleriaEmpresa({ intl });

  const [lightboxZoomOpen, setLightboxZoomOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <Layout location={location}>
      <Helmet bodyAttributes={{ class: `page-template page-template-page-empresa page-template-page-empresa-php page page-id-41 full-width custom-font-enabled single-author mob-menu-slideout ${lightboxZoomOpen ? 'body-overflow-y-hidden' : ''}` }}>
        <title>{intl.formatMessage({ id: 'Empresa | Ideia 2001' })}</title>
      </Helmet>

      <section className="fundoAmarelo">
        <div className="container mt-5">
          <div className="row">
            <div className="col-lg-4 col-md-12 textoQuem mt-40">
              <h1 className="tt-u">{intl.formatMessage({ id: 'Quem Somos' })}</h1>
              <h2 className="mb-4">{intl.formatMessage({ id: 'conheça a' })} <strong>{intl.formatMessage({ id: 'Ideia 2001' })}</strong></h2>
              <p>{intl.formatMessage({ id: 'A Ideia 2001 é uma empresa de desenvolvimento de softwares especializada em catálogos eletrônicos para o mercado de autopeças' })}.</p>
            </div>
            <div className="col-lg-8 col-md-12 imagemAmarelaEmpresa">
              <img src={ImgFundoEmpresa} alt="imagem-fundo-empresa" />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="row mt-5 mb-5">
            <div className="col-lg-7 col-md-12 textoEmpresa">
              <p>{intl.formatMessage({ id: 'Com mais de 25 anos no mercado desenvolvemos mais de 1.000 catálogos para o setor de autopeças, motopeças, máquinas, ferramentas e bicicletas' })}.</p>
              <p>{intl.formatMessage({ id: 'Adquirimos grande experiência e conhecimento técnico para atender as necessidades da sua empresa e valorizar seus produtos quando o assunto é catálogo eletrônico' })}.</p>
              <p>{intl.formatMessage({ id: 'A Ideia 2001 tem como prioridade a satisfação dos seus clientes, para isso, possui uma equipe de profissionais altamente eficientes, qualificados e competentes' })}.</p>
              <p>{intl.formatMessage({ id: 'Sempre aperfeiçoando soluções práticas e objetivas com o intuito de evoluir junto com seus clientes, a Ideia 2001 vem construindo parcerias de sucesso com pequenas, médias e grandes empresas' })}.</p>
              <p>{intl.formatMessage({ id: 'No ramo de catálogos de peças e produtos, somos uma das empresas mais reconhecidas no mercado por aliar tecnologia, facilidade e design, colaborando com o relacionamento da sua companhia e seu usuário final, tornando o catálogo de produtos como um ótimo investimento para as vendas e o crescimento da sua empresa' })}.</p>

              <strong className="tt-u mt-5">{intl.formatMessage({ id: 'Missão' })}</strong>
              <p>{intl.formatMessage({ id: 'Desenvolver e consolidar o melhor catálogo eletrônico do mercado de autopeças, evoluindo constantemente para estar sempre a frente da concorrência e ser reconhecida pelas empresas como parceria ideal' })}.</p>

              <strong className="tt-u">{intl.formatMessage({ id: 'Visão' })}</strong>
              <p>{intl.formatMessage({ id: 'Ser reconhecida pelo mercado de autopeças como referência em catálogos eletrônicos e ferramenta de venda de peças. Crescer com consistência para manter a qualidade dos produtos e serviços prestados' })}.</p>

              <strong className="tt-u">{intl.formatMessage({ id: 'Valores' })}</strong>
              <p>{intl.formatMessage({ id: 'Desenvolver um produto excelente por um preço justo. Garantia de confidencialidade das informações de cada cliente. Perfeccionismo e confiabilidade do sistema. Dedicação no atendimento e no suporte ao cliente' })}.</p>
            </div>
            <div className="col-lg-1 col-md-12"></div>
            <div className="col-lg-4 col-md-12 diferenciais">
              <h2 className="tt-u"><strong>{intl.formatMessage({ id: 'Nossos' })}</strong> {intl.formatMessage({ id: 'Diferenciais' })}</h2>
              {configDiferenciais && configDiferenciais.length ? (
                <ul className="row qualidade ml-0">
                  {configDiferenciais.map((config) => (
                    <li className="col-12" key={config}>
                      <h3>{config}</h3>
                    </li>
                  ))}
                </ul>
              ) : null}
              <div className="row">
                <div className="col-12">
                  {configGaleriaEmpresa && configGaleriaEmpresa.length ? (
                    <div id="galeria_de_fotos">
                      <ul>
                        {configGaleriaEmpresa.map((config, index) => (
                          <li key={index}>
                            <ButtonBase
                              onClick={() => {
                                setPhotoIndex(index);
                                setLightboxZoomOpen(true);
                              }}
                              onKeyDown={(event) => {
                                if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
                                  return;
                                }

                                setPhotoIndex(index);
                                setLightboxZoomOpen(true);
                              }}
                              style={{ width: '100%' }}
                            >
                              <img src={config.sizes.medium} alt={config.alt} />
                            </ButtonBase>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null}
                </div>
              </div>
              <LightboxZoom
                open={lightboxZoomOpen}
                onClose={() => setLightboxZoomOpen(false)}
                images={configGaleriaEmpresa}
                photoIndex={photoIndex}
                setPhotoIndex={setPhotoIndex}
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};
